import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { WastelandRun } from "../components/WastelandRun";

export default function Game() {
  return (
    <main className="game-page" data-testid="game-page">
      <section className="game-shell">
        <Link to="/" className="back-link" data-testid="game-back-link">
          <ArrowLeft size={16} /> BACK TO DOLO'S WORLD
        </Link>
        <Reveal className="game-head">
          <span>BLACK-OPS NET ARCADE // TRAINING SIM 07</span>
          <h1>OUTRUN THE WORM.</h1>
          <p>
            The League's favorite training sim: one runner, one wasteland, one mutated demonic sand worm. Official
            runner regulations apply — if it catches you, the run never happened.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <WastelandRun />
        </Reveal>
        <p className="game-note">SPACE / TAP TO JUMP — DOUBLE JUMP ARMED. CREDITS FEED THE SCORE.</p>
      </section>
      <Footer />
    </main>
  );
}
